export default __webpack_public_path__ + "static/media/icon-play.6f8c55dd.svg";